import * as React from "react";

interface IMoreOverlayComponentProps {
  className: string;
  sizeOfRemain: number;
}

const MoreOverlayComponent = ({ className, sizeOfRemain }: IMoreOverlayComponentProps) => {
  return (
    <div className={className}>
      +{sizeOfRemain}
    </div>
  );
};

export default MoreOverlayComponent;
